import { tabletBreakpoint } from 'core/layouts/ui-blocks/ReusableStyles';
import { colorPalette } from 'core/layouts/ui-blocks/ColorPalette';

export const profileButtonStyles = {
	profileButton: {
		minWidth: 'unset',
		padding: 0,

		textTransform: 'none',

		display: 'flex',
		alignItems: 'center',
		gap: '12px',

		'& svg': {
			height: '16px',
			width: 'auto',
		},
	},
	avatarCont: {
		flexShrink: 0,
		height: '32px',
		width: '32px',
		borderRadius: '50%',

		overflow: 'hidden',

		'& img': {
			height: '100%',
			width: '100%',
			objectFit: 'cover',
		},
	},

	avatar: {
		height: '100%',
		width: '100%',
		backgroundColor: 'colors.dark1',

		'& svg': {
			height: '100%',
			width: '100%',
			objectFit: 'cover',
		},
	},

	popover: {
		transform: 'translateY(8px)',

		'& .MuiPopover-paper': {
			display: 'flex',
			backgroundColor: 'colors.dark3',
		},
	},
	popoverContainer: {
		minWidth: '280px',

		backgroundColor: 'colors.dark4',

		display: 'flex',
		flexDirection: 'column',
	},
	profileDetails: {
		width: '100%',
		padding: '14px 16px',
		flexDirection: 'column',
		display: 'flex',
		gap: '8px',
	},
	popoverOption: {
		width: '100%',
		padding: '14px 16px',

		display: 'flex',
		gap: '8px',
	},
	creditsComp: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'end',
	},
	popoverDivider: {
		width: '100%',
		borderBottom: `1px solid ${colorPalette.dark2}`,
	},

	signInButton: {
		padding: { xs: '4px 16px', [tabletBreakpoint]: '4px' },
		minWidth: { xs: 'unset', [tabletBreakpoint]: '160px' },
		minHeight: '44px',
		borderRadius: '53px',
		borderWidth: '1px',
		borderStyle: 'solid',
		borderColor: 'colors.dark1',

		backgroundColor: 'colors.dark3',

		textTransform: 'none',

		display: 'flex',
		alignItems: 'center',
		gap: '4px',

		'&:hover': {
			backgroundColor: 'colors.dark3',
		},
	},
	signInButtonTxt: {
		color: 'colors.light1',
	},

	drawerContainer: {
		width: { xs: '100vw', mm: '360px' },
		flexGrow: 1,
		padding: { xs: '24px 16px', [tabletBreakpoint]: '24px 16px' },

		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'space-between',
		gap: '60px',
	},
	drawer: {
		divider: {
			width: '100%',
			borderBottom: `1px solid ${colorPalette.dark4}`,
		},

		menuItem: {
			width: '100%',
			padding: '8px',

			display: 'flex',
			alignItems: 'center',
			gap: '4px',

			cursor: 'pointer',

			'& svg': {
				height: 'auto',
				width: '16px',
			},
		},
	},
};
